import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { MVKPhase } from '../types/mvk_state';
import { toggleValueInArray } from '../utils/array/toggleValueInArray';
import { generateInitialState } from '../utils/mvk_state';
export var defaultMVKState = {
  flat: {},
  house: {},
  isFullScreen: false,
  map: {
    infrastructureList: [],
    isNoPanorama: false,
    isPanoramaActive: false,
    isRulerActive: false,
    selectedInfrastructureTypes: []
  },
  phase: MVKPhase.PREVIEW,
  section: {},
  sectionPhaseFilters: {},
  shouldIgnoreScroll: false,
  shouldShowFullScreenTip: false,
  isOfferCard: false
};
export function mvkStateReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultMVKState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'ISetInfrastructureListAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        map: _objectSpread(_objectSpread({}, state.map), {}, {
          infrastructureList: action.infrastructureList
        })
      });
    case 'IToggleSelectedInfrastructureTypeAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        map: _objectSpread(_objectSpread({}, state.map), {}, {
          selectedInfrastructureTypes: toggleValueInArray(action.infrastructureType, state.map.selectedInfrastructureTypes)
        })
      });
    case 'IClearSelectedInfrastructureTypesAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        map: _objectSpread(_objectSpread({}, state.map), {}, {
          selectedInfrastructureTypes: []
        })
      });
    case 'ISetRulerActiveAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        map: _objectSpread(_objectSpread({}, state.map), {}, {
          isRulerActive: action.isRulerActive
        })
      });
    case 'ISetPanoramaActiveAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        map: _objectSpread(_objectSpread({}, state.map), {}, {
          isPanoramaActive: action.isActive
        })
      });
    case 'ISetNoPanoramaAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        map: _objectSpread(_objectSpread({}, state.map), {}, {
          isNoPanorama: action.state
        })
      });
    case 'ISetMVKPhaseAction':
      {
        var phase = action.phase;
        var isPreview = phase === MVKPhase.PREVIEW;
        return _objectSpread(_objectSpread({}, state), {}, {
          flat: phase !== MVKPhase.FLAT ? {} : state.flat,
          house: isPreview ? {} : state.house,
          map: _objectSpread(_objectSpread({}, state.map), {}, {
            isNoPanorama: false,
            isPanoramaActive: false
          }),
          phase: phase,
          section: isPreview ? {} : state.section,
          sectionPhaseFilters: isPreview ? {} : state.sectionPhaseFilters
        });
      }
    case 'ISetHoveredHouseIdAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        house: _objectSpread(_objectSpread({}, state.house), {}, {
          hoveredId: action.houseId
        })
      });
    case 'ISetHoveredSectionIdAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        house: _objectSpread(_objectSpread({}, state.house), {}, {
          hoveredId: action.houseId
        }),
        section: _objectSpread(_objectSpread({}, state.section), {}, {
          hoveredId: action.sectionId
        }),
        shouldIgnoreScroll: Boolean(action.shouldIgnoreScroll)
      });
    case 'ISetHoveredFlatIdAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        flat: _objectSpread(_objectSpread({}, state.flat), {}, {
          hoveredId: action.flatId
        })
      });
    case 'ISetHouseIdAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        flat: {},
        house: {
          hoveredId: undefined,
          id: action.houseId
        },
        map: _objectSpread(_objectSpread({}, state.map), {}, {
          isNoPanorama: false,
          isPanoramaActive: false
        }),
        section: {}
      });
    case 'ISetSectionIdAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        flat: {},
        map: _objectSpread(_objectSpread({}, state.map), {}, {
          isNoPanorama: false,
          isPanoramaActive: false
        }),
        phase: MVKPhase.SECTION,
        section: {
          hoveredId: undefined,
          id: action.sectionId
        }
      });
    case 'ISetFlatIdAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        flat: {
          hoveredId: undefined,
          id: action.flatId
        },
        phase: MVKPhase.FLAT
      });
    case 'IToggleFlatFilterAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        sectionPhaseFilters: _objectSpread(_objectSpread({}, state.sectionPhaseFilters), {}, {
          selectedFlatTypes: toggleValueInArray(action.flatType, state.sectionPhaseFilters.selectedFlatTypes)
        })
      });
    case 'ISetFloorFilterAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        sectionPhaseFilters: _objectSpread(_objectSpread({}, state.sectionPhaseFilters), {}, {
          selectedFloor: action.floor
        })
      });
    case 'IToggleFullScreenAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFullScreen: action.state
      });
    case 'IChangeFullScreenTipVisiblityAction':
      return _objectSpread(_objectSpread({}, state), {}, {
        shouldShowFullScreenTip: action.state
      });
    case 'IToggleRouteUpdateAction':
      if (action.isInitial) {
        return state;
      }
      return generateInitialState(defaultMVKState, action.queryString);
    default:
      return state;
  }
}